import { render, staticRenderFns } from "./ThirdFloor.vue?vue&type=template&id=83615e24&scoped=true&"
import script from "./ThirdFloor.vue?vue&type=script&lang=js&"
export * from "./ThirdFloor.vue?vue&type=script&lang=js&"
import style0 from "./ThirdFloor.vue?vue&type=style&index=0&id=83615e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83615e24",
  null
  
)

export default component.exports